import { AxiosResponse } from 'axios';
import { Const } from '~/constants/Const.constant';
import { DataApiResponse } from '~/interfaces/api.interface';
import { ConfigModule } from '~/store/modules/config';
import { OperatorModule } from '~/store/modules/operator';
import { LoadingModule } from '~common-store/modules/loading';
import { NotificationsModule } from '~common-store/modules/notifications';

const UNAUTHORIZED_ERROR = 401;
const FORBIDDEN_ERROR = 403;
const {
    REQUIRED_TFA,
} = Const.NARestErrorCode;

function refreshToken() {
    OperatorModule.refreshToken();
    return {
        errType: 'warning',
        errMsg: 'refreshing your token'
    };
}

// Catches error connection or any other error (checks if error.response exists)
export const handleError = (error: DataApiResponse, textFailure?: string) => {
    let errMsg = '';
    let errType = 'error';
    LoadingModule.showLoading(false);
    const duration = 1500;
    if (error.response) {
        if (error.response.data.error.code) {
            errMsg = `ERROR ${error.response.data.error.code}: ${error.response.data.error.message}`;
        } else {
            errMsg = error.response.data.error.message;
        }
        if (!ConfigModule.accessToken) {
            ({ errMsg, errType } = refreshToken());
        }
        switch (error.response.status) {
            case UNAUTHORIZED_ERROR:
                ({ errMsg, errType } = refreshToken());
                break;
            case FORBIDDEN_ERROR:
                if (error.response.data?.error?.details?.code === REQUIRED_TFA) {
                    window.location.href = `${ConfigModule.usersManagementUrl}/auth/tfa`;
                } else {
                    ({ errMsg, errType } = refreshToken());
                }
        }
    } else if (error.request) {
        /*
         * The request was made but no response was received, `error.request`
         * is an instance of XMLHttpRequest
         */
        errMsg = 'NO RESPONSE FROM SERVER';
    } else {
        // Any other error
        errMsg = error.message;
    }

    NotificationsModule.pushNotification({
        title: errType === 'error' ? 'Error' : 'Token error',
        text: textFailure || errMsg,
        type: errType,
        duration,
    });
};

export const buildSuccess = (response: AxiosResponse, msg: string) => {
    if (response.status === 200) {
        LoadingModule.showLoading(false);
        NotificationsModule.pushNotification({
            title: msg,
            type: 'success',
        });
    }
};
